import { render } from "./ProjectBuilder.vue?vue&type=template&id=edfdaf54"
import script from "./ProjectBuilder.vue?vue&type=script&lang=js"
export * from "./ProjectBuilder.vue?vue&type=script&lang=js"

import "./ProjectBuilder.vue?vue&type=style&index=0&id=edfdaf54&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__